import type { RouteRecordRaw } from 'vue-router'

const routers: RouteRecordRaw = {
  path: '/shp-coupon',
  name: 'ShpCoupon',
  meta: {
    title: '优惠券管理'
  },
  children: [
    {
      path: 'list',
      name: 'ShpCouponList',
      meta: {
        title: '优惠券列表'
      },
      component: () => import('@/views/shp-coupon/ShpCouponList.vue')
    },
    {
      path: 'redemptions',
      name: 'ShpCouponRedemptionList',
      meta: {
        title: '核销记录'
      },
      component: () => import('@/views/shp-coupon/ShpCouponRedemptionList.vue')
    }
  ]
}

export default routers
